
//Hide links to key info if the section is not on the page
jQuery(function($){

	if( !($('.section-key-info').length) ) {

        $('.js-key-info-link').hide(); 

	}

});




